import axios from 'axios';

/**
 * Instância única do axios. Centraliza:
 *  - baseURL da API
 *  - anexar o JWT em toda request (interceptor de request)
 *  - deslogar automaticamente em 401 de request autenticada (interceptor de response)
 *
 * Assim nenhum serviço precisa mais montar header/token na mão.
 */
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

export const getToken = () => localStorage.getItem('token');
export const setToken = (token: string) => localStorage.setItem('token', token);
export const clearToken = () => localStorage.removeItem('token');

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url: string = error?.config?.url ?? '';
    const status: number | undefined = error?.response?.status;

    // Endpoints públicos de auth tratam o 401 na própria tela (ex.: senha errada).
    // Só forçamos logout quando é uma request autenticada que expirou/foi rejeitada.
    const ehAuthPublico = url.includes('/auth/') || url.includes('/usuarios/login') || url.includes('/usuarios/me');

    if (status === 401 && !ehAuthPublico) {
      clearToken();
      if (window.location.pathname !== '/') {
        window.location.assign('/');
      }
    }
    return Promise.reject(error);
  }
);

export default api;
